import { Component } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'simulador';
}

$.fn.shake = function(interval ?: number, distance ?: number, times ?: number) {
  interval = typeof interval === 'undefined' ? 100 : interval;
  distance = typeof distance === 'undefined' ? 10 : distance;
  times = typeof times === 'undefined' ? 3 : times;

  const jTarget = $(this);

  jTarget.css('position', 'relative');

  for (let iter = 0; iter < (times + 1); iter++) {
    jTarget.animate({ left: ((iter % 2 === 0 ? distance : distance * - 1))}, interval);
  }

  return jTarget.animate({ left: 0 }, interval);
};
